module.exports = __webpack_public_path__ + "img/yan12.78553d09.png";